import { Component, NgZone, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { FormService } from 'src/app/services/form.service';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css'],
})
export class EditProfileComponent implements OnInit, AfterViewInit {
  editProfile!: FormGroup;
  props: any = {};
  faith: string = '';
  faiths: [] = [];
  selectedFaith: string = '';
  subFaith: string = '';
  subFaiths: [] = [];
  subFaith2: string = '';
  subFaiths2: [] = [];
  faithDenomination: [] = [];
  communityType: [] = [];
  profilePhoto: string = '';
  converPhoto: string = '';
  uploadedFile: any;
  submitted = false;
  isShowSubfaith: boolean = false;
  isShowSubfaith2: boolean = false;
  baseUrl = environment.imgUrl;
  Title: string = '';
  showButton = false;
  faithList: any;
  totalItems: number = 0;
  faithListLevel2: any[] = [];
  faithListLevel3: any[] = [];
  selectedFaith2: string | null = null;
  selectedFaith3: string | null = null;
  loadMoreArr: any[] = [];
  checkbox: any[] = [];
  loading = false;
  staticButton: boolean = false;
  closeResult: string = '';
  communityName = '';
  currentUser: any;
  communityData: any;
  profilePic: any;
  faithName: any;
  affilatedById: any = '';
  communityResults: any[] = [];
  pageSize: number = 10;
  searchTerm: string = '';
  showError: boolean = false;
  modalError: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 0;
  debouncer: any;
  associationApprovalStatus: boolean = false;
  selectedAssociationStatus: string = '';
  // NEW: Multi-select state for ministry headquarters
  selectedHeadquarterIds: string[] = [];
  primaryAddressLoc: any = { lat: 0, lng: 0 };
  primaryAddress2Loc: any = { lat: 0, lng: 0 };
  secondaryAddressLoc: any = { lat: 0, lng: 0 };
  secondaryAddress2Loc: any = { lat: 0, lng: 0 };
  // Holds username returned from API; if empty, field stays editable
  initialCommunityUserName: string = '';

  constructor(
    private router: Router,
    private authService: AuthservicesService,
    private modalService: NgbModal,
    private formService: FormService,
    private ngxLoader: NgxUiLoaderService,
    private fb: FormBuilder,
    private zone: NgZone
  ) {
    const localStorageItem = localStorage.getItem('profileData');
    this.props = localStorageItem ? JSON.parse(localStorageItem) : {};
    this.editProfile = this.formService.editProfile;
    if (!this.editProfile.get('subfaithVal')) {
      this.editProfile.addControl('subfaithVal', this.fb.control(''));
    }
    if (!this.editProfile.get('subfaithVal2')) {
      this.editProfile.addControl('subfaithVal2', this.fb.control(''));
    }
    if (!this.editProfile.get('subfaithBranch')) {
      this.editProfile.addControl('subfaithBranch', this.fb.control(''));
    }
    if (!this.editProfile.get('faithDenomination')) {
      this.editProfile.addControl('faithDenomination', this.fb.control(''));
    }
    if (!this.editProfile.get('introduction')) {
      this.editProfile.addControl('introduction', this.fb.control(''));
    }
    if (!this.editProfile.get('generalInfo')) {
      this.editProfile.addControl('generalInfo', this.fb.control(''));
    }
    if (!this.editProfile.get('missionStatement')) {
      this.editProfile.addControl('missionStatement', this.fb.control(''));
    }
    if (!this.editProfile.get('alternateCountryCode')) {
      this.editProfile.addControl('alternateCountryCode', this.fb.control('+91'));
    }
    if (!this.editProfile.get('primaryAddress2')) {
      this.editProfile.addControl('primaryAddress2', this.fb.control(''));
    }
    if (!this.editProfile.get('secondaryAddress2')) {
      this.editProfile.addControl('secondaryAddress2', this.fb.control(''));
    }
    // Ensure associatedBy control is initialized and marked as required
    const associatedByControl = this.editProfile.get('associatedBy');
    if (associatedByControl) {
      associatedByControl.setValue('');
      associatedByControl.setValidators([Validators.required]);
      associatedByControl.updateValueAndValidity();
    }
    const addressControl = this.editProfile.get('address');
    if (addressControl && !addressControl.validator) {
      addressControl.setValidators([Validators.required]);
      addressControl.updateValueAndValidity();
    }

    // Enforce required validators for requested fields
    const introCtrl = this.editProfile.get('introduction');
    if (introCtrl) {
      introCtrl.setValidators([Validators.required]);
      introCtrl.updateValueAndValidity();
    }
    const generalInfoCtrl = this.editProfile.get('generalInfo');
    if (generalInfoCtrl) {
      generalInfoCtrl.setValidators([Validators.required]);
      generalInfoCtrl.updateValueAndValidity();
    }
    const publicEmailCtrl = this.editProfile.get('publicemail');
    if (publicEmailCtrl) {
      publicEmailCtrl.setValidators([Validators.required]);
      publicEmailCtrl.updateValueAndValidity();
    }
    const countryRegCtrl = this.editProfile.get('countryofreg');
    if (countryRegCtrl) {
      countryRegCtrl.setValidators([Validators.required]);
      countryRegCtrl.updateValueAndValidity();
    }
    // Additional required fields matching asterisk-marked inputs
    // const taxIdCtrl = this.editProfile.get('certificateno');
    // if (taxIdCtrl) {
    //   taxIdCtrl.setValidators([Validators.required]);
    //   taxIdCtrl.updateValueAndValidity();
    // }
    const faithCtrl = this.editProfile.get('faith');
    if (faithCtrl) {
      faithCtrl.setValidators([Validators.required]);
      faithCtrl.updateValueAndValidity();
    }
    const ministryTypeCtrl = this.editProfile.get('communitytype');
    if (ministryTypeCtrl) {
      ministryTypeCtrl.setValidators([Validators.required]);
      ministryTypeCtrl.updateValueAndValidity();
    }
    const nameCtrl = this.editProfile.get('name');
    if (nameCtrl) {
      nameCtrl.setValidators([Validators.required]);
      nameCtrl.updateValueAndValidity();
    }
    // Make username required
    const usernameCtrl = this.editProfile.get('communityUserName');
    if (usernameCtrl) {
      usernameCtrl.setValidators([Validators.required]);
      usernameCtrl.updateValueAndValidity();
    }
    const phoneCtrl = this.editProfile.get('phone');
    if (phoneCtrl) {
      phoneCtrl.setValidators([Validators.required]);
      phoneCtrl.updateValueAndValidity();
    }
    const sloganCtrl = this.editProfile.get('logline');
    if (sloganCtrl) {
      sloganCtrl.setValidators([Validators.required]);
      sloganCtrl.updateValueAndValidity();
    }
    // Make Average weekly attendance mandatory
    const avgWeeklyCtrl = this.editProfile.get('avgweeklyattendance');
    if (avgWeeklyCtrl) {
      avgWeeklyCtrl.setValidators([Validators.required]);
      avgWeeklyCtrl.updateValueAndValidity();
    }
    this.pageSize = this.itemsPerPage;
  }

  async ngOnInit() {
    const ministryCurrentUser = localStorage.getItem('ministry_currentUser');
    this.currentUser = ministryCurrentUser ? JSON.parse(ministryCurrentUser) : {};
    await this.getFaiths();
    this.getCommunityId(this.currentUser);
    await this.patchValue(this.props);
    this.getCommunitytypes();

    // Initialize association status as empty
    this.clearAssociationDisplay();
  }

  ngAfterViewInit() {
    // Autocomplete is handled via ngx-google-places-autocomplete directives in the template.
    // The previous manual initAutocomplete() bound Google Places to an element with a
    // non-unique id, which caused suggestions to appear on non-address fields.
  }

  get editProfileInfo() {
    return this.editProfile.controls;
  }

  getAssociationDisplayValue(): string {
    // Always ensure we return a string
    let displayValue = '';

    if (this.selectedAssociationStatus) {
      displayValue = this.selectedAssociationStatus;
    } else if (this.communityData?.associatedBy?.community?.name) {
      displayValue = this.communityData.associatedBy.community.name;
    } else if (typeof this.communityData?.associatedBy === 'string') {
      displayValue = this.communityData.associatedBy;
    }

    // Ensure we always return a string, never an object
    return typeof displayValue === 'string' ? displayValue : '';
  }

  isOptionSelected(optionName: string): boolean {
    return this.selectedAssociationStatus === optionName || this.communityName === optionName;
  }

  // NEW: check if an HQ id is currently selected
  isHeadquarterSelected(id: string): boolean {
    const target = String(id || '');
    return this.selectedHeadquarterIds.some((x: any) => String(x) === target);
  }

  clearAssociationDisplay() {
    this.selectedAssociationStatus = '';
    this.communityName = '';
    this.affilatedById = '';
    this.associationApprovalStatus = false;
    this.selectedHeadquarterIds = [];
    this.editProfile.get('associatedBy')?.setValue('');
    // Force change detection
    setTimeout(() => {
      this.editProfile.get('associatedBy')?.setValue('');
    }, 0);
  }

  // initAutocomplete() and AddressChange() are no longer used because
  // ngx-google-places-autocomplete handles address suggestions directly
  // on the relevant inputs in the template.

  // NEW: Handler for ngx-google-places-autocomplete
  handleAddressChange(
    place: any,
    control: 'address' | 'address2' | 'primaryAddress2' | 'secondaryAddress2'
  ) {
    const lat = place?.geometry?.location?.lat?.() || 0;
    const lng = place?.geometry?.location?.lng?.() || 0;
    const selectedValue =
      place?.formatted_address ||
      (place?.name && place?.vicinity ? `${place.name}, ${place.vicinity}` : '') ||
      place?.name ||
      place?.vicinity ||
      '';

    this.zone.run(() => {
      this.editProfile.get(control)?.setValue(selectedValue, { emitEvent: false });
      this.editProfile.get(control)?.markAsDirty();
      this.editProfile.get(control)?.updateValueAndValidity({ emitEvent: false });

      if (control === 'address') {
        this.primaryAddressLoc = { lat, lng };
      } else if (control === 'primaryAddress2') {
        this.primaryAddress2Loc = { lat, lng };
      } else if (control === 'address2') {
        this.secondaryAddressLoc = { lat, lng };
      } else if (control === 'secondaryAddress2') {
        this.secondaryAddress2Loc = { lat, lng };
      }
    });
  }

  async patchValue(props: any) {
    this.ngxLoader.startLoader('loader-03');
    // CHANGED: Log props to inspect data structure

    // Wait for faiths to be populated
    if (this.faiths.length > 0) {
      this.faiths.forEach((faith: any) => {
        if (faith['_id'] === (props?.faith?._id || '')) {
          this.subFaiths = faith.subcategory || [];
        }
      });

      this.subFaiths?.forEach((subfaith: any) => {
        if (subfaith?._id === (props?.subFaith?._id || '')) {
          this.subFaiths2 = subfaith.subcategory || [];
        }
      });
    }

    // CHANGED: Safely patch values with fallback to empty strings
    const firstAltAddr = Array.isArray(props?.alternateAddress) && props.alternateAddress.length > 0
      ? props.alternateAddress[0]
      : null;
    const patchData = {
      email: props?.email || '',
      // Support both possible key casings from stored profile data
      androidapplink: props?.androidapplink || props?.androidAppLink || '',
      iOSappLInk: props?.iOSappLInk || props?.iosAppLink || '',
      name: props?.name || '',
      logline: props?.logLine || '',
      address: props?.primaryAddress?.address || props?.address?.streetAddress || props?.address || '',
      primaryAddress2: props?.primaryAddress2?.address || '',
      address2: props?.secondaryAddress?.address || firstAltAddr?.streetAddress || firstAltAddr?.googleAddress || '',
      secondaryAddress2: props?.secondaryAddress2?.address || '',
      bridgenumber: props?.bridgeNumber || '',
      phone: this.extractPhoneNumber(props?.contactNo || ''),
      countryCode: this.extractCountryCode(props?.contactNo || '') || '+1',
      guitarstarid: props?.guideStarID || '',
      faith: props?.faith?._id || '',
      communitytype: props?.profitType?.map((type: any) => type.id) || [],
      certificateno: props?.certificateNo || '',
      alternatecontactnumber: this.extractPhoneNumber(props?.AlternateContactNO || ''),
      alternateCountryCode: this.extractCountryCode(props?.AlternateContactNO || '') || '+91',
      publicemail: props?.publicEmail || '',
      countryofreg: props?.countryOFReg || '',
      avgweeklyattendance: props?.avgWeeklyAttendence || '',
      communityUserName: props?.communityUserName || '',
      associatedBy: '',
      photo: props?.photo || '',
      coverPhoto: props?.coverPhoto || '',

      subfaithVal: props?.subFaith?._id || '',
      subfaithVal2: props?.subFaithSub?._id || '',
      subfaithBranch: props?.faithBranch?._id || '',
      faithDenomination: props?.faithDenomination?._id || '',
      introduction: props?.introduction || '',
      generalInfo: props?.generalInfo || '',
      // Backend may return either missionStatement or missionStateMent
      missionStatement: props?.missionStatement || props?.missionStateMent || '',
    };


    this.editProfile.patchValue(patchData);

    // Record initial username from API payload if present
    this.initialCommunityUserName = props?.communityUserName || this.initialCommunityUserName || '';

    // Initialize address coordinate holders from existing profile data so that
    // subsequent saves preserve correct locations even without changing addresses.
    if (props?.primaryAddress?.coordinates?.length === 2) {
      this.primaryAddressLoc = {
        lng: props.primaryAddress.coordinates[0],
        lat: props.primaryAddress.coordinates[1],
      };
    }
    if (props?.primaryAddress2?.coordinates?.length === 2) {
      this.primaryAddress2Loc = {
        lng: props.primaryAddress2.coordinates[0],
        lat: props.primaryAddress2.coordinates[1],
      };
    }
    if (props?.secondaryAddress?.coordinates?.length === 2) {
      this.secondaryAddressLoc = {
        lng: props.secondaryAddress.coordinates[0],
        lat: props.secondaryAddress.coordinates[1],
      };
    }
    if (props?.secondaryAddress2?.coordinates?.length === 2) {
      this.secondaryAddress2Loc = {
        lng: props.secondaryAddress2.coordinates[0],
        lat: props.secondaryAddress2.coordinates[1],
      };
    }


    this.selectedFaith = props?.faith?._id || '';
    this.subFaith = props?.subFaith?._id || '';
    this.subFaith2 = props?.faithBranch?._id || '';

    // Populate subFaiths2 (branches) from selected faith
    if (this.selectedFaith) {
      this.faiths.forEach((faith: any) => {
        if (faith['_id'] == this.selectedFaith) {
          this.subFaiths2 = faith.subcategory || [];
        }
      });
    }

    // Populate faithDenomination from selected branch
    if (this.subFaith2) {
      this.subFaiths2.forEach((branch: any) => {
        if (branch['_id'] == this.subFaith2) {
          this.faithDenomination = branch.subcategory || [];
        }
      });
    }

    this.profilePhoto = props?.photo || '';
    this.converPhoto = props?.coverPhoto || '';
    this.ngxLoader.stopLoader('loader-03');
  }

  getCommunitytypes() {
    let skip: number = 0;
    let limit: number = 100;
    this.authService.getCommunityType(skip, limit).subscribe((res: any) => {
      this.communityType = res.items;
    });
  }

  async getFaiths() {
    let skip: number = 0;
    let limit: number = 100;
    let result: any = await this.authService.getFaith(skip, limit).toPromise();
    const allFaiths = result?.data || [];
    // Restrict selection to only 'Christian'
    this.faiths = allFaiths.filter(
      (item: any) => (item?.name || '').toLowerCase() === 'christian'
    );

    // let faithRecords=result?.data;
    // if(faithRecords.length>0){
    //   let christianRecords=faithRecords.filter((item:any)=>item.name == 'Christian')
    //   this.faith=christianRecords
      
    // }
  }

  changeFaithVal(event: any) {
    // this.editProfile.controls['faith'].setValue(event.name);
    this.subFaith = '';
    this.subFaith2 = '';
    this.editProfile.patchValue({ subfaithVal: '', subfaithBranch: '', faithDenomination: '' });
    this.faiths.forEach((faith: any) => {
      if (faith['_id'] == this.selectedFaith) {
        this.subFaiths2 = faith.subcategory || [];
      }
    });
  }

  changeSubFaithVal(data: any) {
    this.subFaith = data;
    this.editProfile.patchValue({
      subfaithVal: data._id,
      subfaithVal2: '',
    });
    this.subFaiths.forEach((subfaith: any) => {
      if (subfaith['_id'] == this.subFaith) {
        this.subFaiths2 = subfaith.subcategory || [];
      }
    });
  }

  changeSubFaithBranch(data: any) {
    this.faithDenomination = data.subcategory || [];
    this.editProfile.patchValue({ subFaithBranch: data._id });
  }
  changeSubFaithDenomination(data: any) {
    this.editProfile.get('faithDenomination')?.setValue(data?._id || '');
  }

  changeSubFaith2Val(event: any) {
    this.subFaith2 = event.target.value;
    this.editProfile.patchValue({ subfaithVal2: this.subFaith2 });
  }

  getErrorImage(event: Event) {
    this.authService.geterrorImage(event);
  }

  navigate() {
    return this.router.navigate([
      '/fellowship-directory/our-network',
      this.props._id,
    ]);
  }

  renderImage(photo: string) {
    if (photo != null) {
      const [baseUrl, imgUrl] = photo.split('uploads');
      // return `https://services.ravel.faith/uploads${imgUrl}`;
      return `http://localhost:9000/uploads${imgUrl}`;
    }
    return 'assets/images/church.jpeg';
  }

  changeProfilePhoto(event: any) {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];
      this.uploadedFile = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'profilePic');
      this.ngxLoader.startLoader('loader-02');
      this.authService.upload(formData).subscribe(
        (data: any) => {
          this.profilePhoto = data?.data?.url || '';
          // this.renderImage(this.profilePhoto)
          this.ngxLoader.stopLoader('loader-02');
        },
        (error) => {
          this.ngxLoader.stopLoader('loader-01');
          this.authService.successMessage(error.error.message, 'error');
        }
      );
    }
  }

  changeCoverPhoto(event: any) {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];
      this.uploadedFile = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');
      this.ngxLoader.startLoader('loader-01');
      this.authService.upload(formData).subscribe(
        (data: any) => {
          this.converPhoto = data?.data?.url || '';
          // this.renderImage(this.profilePhoto
          this.ngxLoader.stopLoader('loader-01');
        },
        (error) => {
          this.ngxLoader.stopLoader('loader-01');
          this.authService.successMessage(error.error.message, 'error');
        }
      );
    }
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.editProfile.invalid) {
      this.authService.successMessage('Please complete all required fields', 'error');
      this.scrollToFirstInvalid();
      return;
    }
    // Determine HQ/Satellite profile type for backend
    const isHQ = this.selectedAssociationStatus === 'Headquarters';
    const isSatellite = this.selectedAssociationStatus === 'Satellite Campus';
    const myId = this.communityData?._id || this.currentUser?.id || '';
    // Build parent HQ ids: for Satellite allow multiple selections, fallback to single selected id if present
    const parentHQIds: string[] = isHQ
      ? []
      : (isSatellite
        ? (this.selectedHeadquarterIds?.length
          ? [...this.selectedHeadquarterIds]
          : (this.affilatedById ? [this.affilatedById] : []))
        : []);

    if (isSatellite && parentHQIds.length === 0) {
      this.authService.successMessage('Please select a Ministry Headquarters for Satellite Campus', 'error');
      return;
    }
    // Build associatedBy per new rules
    let associatedByPayload: any[] = [];
    if (isSatellite && parentHQIds.length > 0) {
      associatedByPayload = parentHQIds.map((id: string) => ({ community: id, associationType: 'Satellite' }));
    } else {
      // Headquarters or none: clear associatedBy
      associatedByPayload = [];
    }
    if(associatedByPayload.length>0)
    {
    const filterAssociation=associatedByPayload.filter((item)=> item.community != this.currentUser._id)
      associatedByPayload=filterAssociation
    }


    const addr2Val = this.editProfile.value.address2 || '';
    const alternateAddressPayload = addr2Val
      ? [{
        googleAddress: addr2Val,
        streetAddress: addr2Val,
        isMain: false,
        location: { type: 'Point', coordinates: [] as number[] }
      }]
      : [];

    let formData = {
      email: this.editProfile.value.email || '',
      name: this.editProfile.value.name || '',
      logLine: this.editProfile.value.logline || '',
      contactNo: this.formatPhoneNumber(this.editProfile.value.countryCode, this.editProfile.value.phone),
      faith: this.editProfile.value.faith,
      profitType: this.editProfile.value.communitytype || [],
      // New HQ/Satellite flow
      profileType: isHQ ? 'headquarters' : (isSatellite ? 'satellite' : ''),
      // For Satellite, send array of objects {id, status:'pending'}; for HQ/none, send empty array
      parentHeadquarters: isSatellite ? parentHQIds.map(id => ({ id, status: 'pending' })) : [],
      isHeadquarters: !!isHQ,

      alternateAddress: alternateAddressPayload,
      photo: this.profilePhoto || '',
      coverPhoto: this.converPhoto || '',
      androidapplink: this.editProfile.value.androidapplink || '',
      iOSappLInk: this.editProfile.value.iOSappLInk || '',
      bridgeNumber: this.editProfile.value.bridgenumber || '',
      guideStarID: this.editProfile.value.guitarstarid || '',
      introduction: this.editProfile.value.introduction || '',
      generalInfo: this.editProfile.value.generalInfo || '',
      missionStatement: this.editProfile.value.missionStatement || '',
      certificateNo: this.editProfile.value.certificateno || '',
      AlternateContactNO: this.formatPhoneNumber(this.editProfile.value.alternateCountryCode, this.editProfile.value.alternatecontactnumber),
      publicEmail: this.editProfile.value.publicemail || '',
      countryOFReg: this.editProfile.value.countryofreg || '',
      avgWeeklyAttendence: this.editProfile.value.avgweeklyattendance || '',
      communityUserName: this.editProfile.value.communityUserName || '',
      associatedBy: associatedByPayload,

      faithBranch: this.editProfile.value.subfaithBranch || '',
      faithDenomination: this.editProfile.value.faithDenomination || '',
      primaryAddress: {
        type: 'Point',
        coordinates: [this.primaryAddressLoc.lng, this.primaryAddressLoc.lat],
        address: this.editProfile.value.address || ''
      },
      primaryAddress2: {
        type: 'Point',
        coordinates: [this.primaryAddress2Loc.lng, this.primaryAddress2Loc.lat],
        address: this.editProfile.value.primaryAddress2 || ''
      },
      secondaryAddress: {
        type: 'Point',
        coordinates: [this.secondaryAddressLoc.lng, this.secondaryAddressLoc.lat],
        address: this.editProfile.value.address2 || ''
      },
      secondaryAddress2: {
        type: 'Point',
        coordinates: [this.secondaryAddress2Loc.lng, this.secondaryAddress2Loc.lat],
        address: this.editProfile.value.secondaryAddress2 || ''
      }
    };

    this.authService.signUpBaseInfo(formData).subscribe(
      (res: any) => {
        const updatedProps = { ...this.props, address: formData.primaryAddress.address };
        localStorage.setItem('profileData', JSON.stringify(updatedProps));
        this.authService.successMessage('Profile Updated', 'success');
        this.router.navigate(['/profile-management']);
      },
      (error) => {
        console.log('error error error', error.error.error);
        const errorMessage = error?.error?.message || 'Complete mandatory fields';
        this.authService.successMessage(errorMessage, 'error');
      
      }
    );
  }

  private scrollToFirstInvalid() {
    setTimeout(() => {
      const firstInvalid = document.querySelector('.is-invalid') as HTMLElement | null;
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof (firstInvalid as any).focus === 'function') {
          (firstInvalid as any).focus({ preventScroll: true });
        }
      }
    }, 0);
  }

  getFaith(event: any) {
    this.showButton = true;
    let skip = event;
    let limit = 1000;
    this.authService.getFaith(skip, limit).subscribe(
      (res: any) => {
        this.loading = true;
        const all = res?.data || [];
        // Restrict modal list to only 'Christian'
        this.faithList = all.filter(
          (item: any) => (item?.name || '').toLowerCase() === 'christian'
        );
        this.totalItems = this.faithList.length;

        const x = this.faithList?.find(
          (faith: any) => faith._id === this.selectedFaith
        );
        this.faithListLevel2 = x?.subcategory;
        const y = this.faithListLevel2?.find(
          (subfaith: any) => subfaith._id === this.selectedFaith2
        );
        this.faithListLevel3 = y?.subcategory;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  open(content: any, title: string) {
    this.Title = title;
    this.loading = false;
    this.loadMoreArr = [];
    this.checkbox = [];
    this.currentPage = 1;
    // this.staticButton = false;
    if (title === 'faith') this.getFaith(0);
    if (title === 'What type of campus are you registering?') {
      this.showButton = false;
      this.loading = true;
      this.staticButton = true;
      this.loadMoreArr.push(
        {
          name: 'Headquarters',
          photo: environment.staticImage,
          type: 'static',
        },
        {
          name: 'Satellite Campus',
          photo: environment.staticImage,
          type: 'static',
        }
      );
      this.totalItems = this.loadMoreArr.length;
      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.loading = false;
    } else {
      this.loading = true;
      this.getCommunity(0);
    }
    this.modalService.open(content, { scrollable: true }).result.then(

      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getCommunityId(data: any) {
    let id = '';
    if (data) {
      id = this.currentUser.id;
    }

    this.authService.getCommunityByid(id).subscribe(
      (res: any) => {
        this.communityData = res.data;

        if (this.communityData) this.fetchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  compareobj(obj: any) {
    let compare = false;
    if (obj) {
      for (let props in this.communityData) {
        for (let innerobj in obj) {
          if ((this.communityName as any)?.[props] == obj[innerobj]) {
            compare = true;
          } else {
            compare = false;
          }
        }
      }
    }
    return compare;
  }

  selectItem(e: any, props: any) {
    // NEW: Multi-select behavior when Title is 'Select Ministry Headquarters'
    if (this.Title === 'Select Ministry Headquarters') {
      const id = props._id;
      if (e.target.checked) {
        if (id && !this.selectedHeadquarterIds.includes(id)) {
          this.selectedHeadquarterIds.push(id);
        }
      } else {
        this.selectedHeadquarterIds = this.selectedHeadquarterIds.filter(x => x !== id);
      }
      this.showError = false;
      return;
    }

    // Existing single-select behavior for association status modal
    this.checkbox = [];
    this.showError = false;

    if (e.target.checked) {
      if (props.type == 'community') {
        this.communityName = props.name;
        this.affilatedById = props._id;
        this.editProfile.get('associatedBy')?.setValue(props.name);
        this.selectedAssociationStatus = '';
        this.associationApprovalStatus = false; // Reset approval status for new selection
      }

      if (props.name === 'Headquarters') {
        this.staticButton = false;
        this.communityName = props.name;
        this.selectedAssociationStatus = props.name;
        this.editProfile.get('associatedBy')?.setValue(props.name);
        this.editProfile.get('associatedBy')?.clearValidators();
        this.editProfile.get('associatedBy')?.updateValueAndValidity();
        this.associationApprovalStatus = false; // Reset approval status for new selection
        this.affilatedById = ''; // Clear community ID for static options
      }

      if (props.name == 'Satellite Campus') {
        this.staticButton = true;
        this.communityName = props.name;
        this.selectedAssociationStatus = props.name;
        this.editProfile.get('associatedBy')?.setValue(props.name);
        this.associationApprovalStatus = false; // Reset approval status for new selection
        this.affilatedById = ''; // Clear community ID for static options
      }

      this.checkbox.push(e.target.value);
    }
  }

  setValidation(key: string) {
    this.editProfile.get(key)?.setValidators([Validators.required]);
    this.editProfile.get(key)?.updateValueAndValidity();
  }

  fetchData() {
    // CHANGED: Log communityData before patching
    const CONTROL = this.editProfile.controls;

    // CHANGED: Patch values from communityData with safe access
    if (this.communityData && this.communityData.name) {
      const communityTypes = this.communityData.profitType?.map((type: any) => type.id) || [];
      const firstAlt = Array.isArray(this.communityData.alternateAddress) && this.communityData.alternateAddress.length > 0
        ? this.communityData.alternateAddress[0]
        : null;
      this.editProfile.patchValue({
        email: this.communityData.email || '',
        name: this.communityData.name || '',
        logline: this.communityData.logLine || '',
        phone: this.communityData.contactNo || '',
        faith: this.communityData.faith?._id || '',
        communitytype: communityTypes,
        address:
          this.communityData.primaryAddress?.address ||
          this.communityData.address?.streetAddress ||
          '',
        primaryAddress2: this.communityData.primaryAddress2?.address || '',
        address2: this.communityData.secondaryAddress?.address || firstAlt?.streetAddress || firstAlt?.googleAddress || '',
        secondaryAddress2: this.communityData.secondaryAddress2?.address || '',
        bridgenumber: this.communityData.bridgeNumber || '',
        guitarstarid: this.communityData.guideStarID || '',
        certificateno: this.communityData.certificateNo || '',
        alternatecontactnumber: this.communityData.AlternateContactNO || '',
        publicemail: this.communityData.publicEmail || '',
        countryofreg: this.communityData.countryOFReg || '',
        avgweeklyattendance: this.communityData.avgWeeklyAttendence || '',
        communityUserName: this.communityData.communityUserName || '',
        associatedBy: '',
        photo: this.communityData.photo || '',
        coverPhoto: this.communityData.coverPhoto || '',

        subfaithVal: this.communityData.subFaith?._id || '',
        subfaithVal2: this.communityData.subFaithSub?._id || '',
        subfaithBranch: this.communityData.faithBranch?._id || '',
        faithDenomination: this.communityData.faithDenomination?._id || '',
        introduction: this.communityData.introduction || '',
        generalInfo: this.communityData.generalInfo || '',
        // Backend may return either missionStatement or missionStateMent
        missionStatement: this.communityData.missionStatement || this.communityData.missionStateMent || '',
        // App links - support both possible key casings from API
        androidapplink: this.communityData.androidapplink || this.communityData.androidAppLink || '',
        iOSappLInk: this.communityData.iOSappLInk || this.communityData.iosAppLink || '',
      });

      // Update component properties
      this.profilePic = this.communityData.photo || '';
      this.converPhoto = this.communityData.coverPhoto || '';
      this.faithName = this.communityData.faith?.name || '';
      // Set initial username from API response (controls readonly state)
      this.initialCommunityUserName = this.communityData.communityUserName || '';
      const affiliatedArr = Array.isArray(this.communityData.associatedBy)
        ? this.communityData.associatedBy
        : (this.communityData.associatedBy ? [this.communityData.associatedBy] : []);
      this.selectedHeadquarterIds = affiliatedArr
        .map((a: any) => (a?.community?._id || a?.community))
        .filter((x: any) => !!x);


      // Determine association selection based on stored data without forcing satellite by default
      const myId = this.currentUser?.id || '';
      const parentHQRaw = this.communityData.parentHeadquarters;
      const normalizeParentId = (p: any) => {
        if (!p) return '';
        if (typeof p === 'string') return p;
        if (p.id) return p.id; // new shape {id, status}
        if (p._id) return p._id; // old populated object
        return '';
      };
      const parentHQIds: string[] = Array.isArray(parentHQRaw)
        ? parentHQRaw.map(normalizeParentId).filter((x: any) => !!x)
        : (parentHQRaw ? [normalizeParentId(parentHQRaw)].filter((x: any) => !!x) : []);

      const isHQFlag = !!(this.communityData.isHeadquarters || this.communityData.isHeadQuarters);
      const legacyAssociatedArr = Array.isArray(this.communityData.associatedBy)
        ? this.communityData.associatedBy
        : (this.communityData.associatedBy ? [this.communityData.associatedBy] : []);
      const hasLegacyAssociation = legacyAssociatedArr.some((item: any) => !!(item?.community?._id || item?.community));
      const hasParentHeadquarters = parentHQIds.length > 0;

      if (isHQFlag || parentHQIds.includes(myId)) {
        this.selectedAssociationStatus = 'Headquarters';
        this.communityName = 'Headquarters';
        this.selectedHeadquarterIds = [];
        this.affilatedById = '';
        this.editProfile.get('associatedBy')?.setValue('Headquarters');
      } else if (hasParentHeadquarters || hasLegacyAssociation) {
        this.selectedAssociationStatus = 'Satellite Campus';
        this.communityName = 'Satellite Campus';
        const effectiveIds = parentHQIds.length > 0 ? parentHQIds : this.selectedHeadquarterIds;
        this.selectedHeadquarterIds = [...effectiveIds];
        this.affilatedById = this.selectedHeadquarterIds[0] || '';
        this.editProfile.get('associatedBy')?.setValue('Satellite Campus');
      } else {
        this.selectedAssociationStatus = '';
        this.communityName = '';
        this.selectedHeadquarterIds = [];
        this.affilatedById = '';
        this.editProfile.get('associatedBy')?.setValue('');
      }
      /* Legacy fallback removed because Association should be determined solely by flags/parent HQs
      else {
        // Fallback to legacy associatedBy array behavior
        const firstAssociation = affiliatedArr[0];
        this.communityName = firstAssociation?.community?.name || '';
        this.selectedAssociationStatus = firstAssociation?.community?.name || '';
        this.affilatedById = this.selectedHeadquarterIds[0] || '';
        this.editProfile.get('associatedBy').setValue(this.selectedAssociationStatus);
      }
      */

      this.selectedFaith = this.communityData.faith?._id || '';
      this.selectedFaith2 = this.communityData.subFaith?._id || '';
      this.selectedFaith3 = this.communityData.subFaithSub?._id || '';
      this.subFaith2 = this.communityData.faithBranch?._id || '';
      // Map boolean approval from associationStatus when present
      if (typeof this.communityData.associationStatus === 'string') {
        this.associationApprovalStatus = this.communityData.associationStatus === 'approved';
      }

      // Populate subFaiths2 (branches) from selected faith
      if (this.selectedFaith) {
        this.faiths.forEach((faith: any) => {
          if (faith['_id'] == this.selectedFaith) {
            this.subFaiths2 = faith.subcategory || [];
          }
        });
      }

      // Populate faithDenomination from selected branch
      if (this.subFaith2) {
        this.subFaiths2.forEach((branch: any) => {
          if (branch['_id'] == this.subFaith2) {
            this.faithDenomination = branch.subcategory || [];
          }
        });
      }

      // Set the associatedBy ID if it exists
      this.affilatedById = this.selectedHeadquarterIds[0] || '';

      // Initialize address coordinate holders from existing community data so that
      // subsequent saves preserve correct locations even without changing addresses.
      if (this.communityData.primaryAddress?.coordinates?.length === 2) {
        this.primaryAddressLoc = {
          lng: this.communityData.primaryAddress.coordinates[0],
          lat: this.communityData.primaryAddress.coordinates[1],
        };
      }
      if (this.communityData.primaryAddress2?.coordinates?.length === 2) {
        this.primaryAddress2Loc = {
          lng: this.communityData.primaryAddress2.coordinates[0],
          lat: this.communityData.primaryAddress2.coordinates[1],
        };
      }
      if (this.communityData.secondaryAddress?.coordinates?.length === 2) {
        this.secondaryAddressLoc = {
          lng: this.communityData.secondaryAddress.coordinates[0],
          lat: this.communityData.secondaryAddress.coordinates[1],
        };
      }
      if (this.communityData.secondaryAddress2?.coordinates?.length === 2) {
        this.secondaryAddress2Loc = {
          lng: this.communityData.secondaryAddress2.coordinates[0],
          lat: this.communityData.secondaryAddress2.coordinates[1],
        };
      }
    }
  }

  createArray(arr: any[], type: string) {
    const data: any[] = [];
    arr.forEach((e: any) => {
      data.push({
        _id: e._id || e.id,
        name: e.name,
        photo: e.photo,
        description: !e.description ? e.shortBio : e.description,
        type: type,
      });
    });
    return data;
  }

  getCommunity(event: any) {
    this.loadMoreArr = [];
    this.checkbox = [];
    const skip = event;
    const query: any = 'selectAssociation';
    this.authService
      .getCommunity(skip, this.pageSize, this.searchTerm, query)
      .subscribe(
        (res: any) => {

          this.communityResults = this.createArray(res.items, 'community');
          this.communityResults = this.communityResults.filter(
            (item: any) => item._id !== this.currentUser.id
          );
          this.totalItems = res.total;
          this.loadMoreArr = this.communityResults;

          this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
          this.loading = false
        },
        (error) => {
          console.log(error);
        }
      );
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    const skip = (this.currentPage - 1) * this.itemsPerPage;
    this.getCommunity(skip);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }


  concatArray(arr: any[], total: number) {
    this.totalItems = total;
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.loadMoreArr = arr; // NEW: Set directly instead of concatenating
    if (this.loadMoreArr.length === 0) {
      this.showButton = false;
    }
    if (this.loadMoreArr.length >= total) {
      this.showButton = false;
    }
  }

  close(content: any) {
    if (this.communityName != '') {
      this.Title = 'Select Ministry Headquarters';
      this.showError = false;
      this.staticButton = false;
      this.currentPage = 1; // NEW: Reset to first page
      this.getCommunity(0);
    } else if (this.affilatedById != '') {
      this.showError = false;
      this.loading = false;
      this.staticButton = false;
    } else {
      this.showError = true;
      this.modalError = 'Please Select one of them.';
    }
  }

  showMore() {
    this.nextPage();
  }

  search(event: any) {
    if (this.debouncer) {
      clearTimeout(this.debouncer);
    }
    this.debouncer = setTimeout(() => {
      this.searchTerm = event?.target?.value || '';
      this.currentPage = 1;
      this.loading = true;
      this.getCommunity(0);
    }, 500);
  }

  extractCountryCode(phone: string): string {
    const supportedCodes = ['+91', '+1', '+44', '+61', '+971'];
    if (!phone) return '';
    for (const code of supportedCodes) {
      if (phone.startsWith(code)) {
        return code;
      }
    }
    return '';
  }

  extractPhoneNumber(phone: string): string {
    const supportedCodes = ['+91', '+1', '+44', '+61', '+971'];
    if (!phone) return '';
    for (const code of supportedCodes) {
      if (phone.startsWith(code)) {
        return phone.substring(code.length);
      }
    }
    return phone;
  }

  formatPhoneNumber(code: string, number: string): string {
    if (!number) return '';
    if (number.startsWith('+')) return number; // Already has code
    return (code || '+1') + number;
  }
}
